// validation.js

import { min } from "moment";
import {
  ADM_ITEM_TYPE,
  ERROR_MESSAGES,
  REG_ITEM_TYPE,
  SEQ_ITEM_TYPE,
} from "./constants";
import { formattedPrice } from "../utils";

export const validatePartialPayment = (
  enteredAmount,
  selectedComponents,
  totalSelectedAmount,
  configuration
) => {
  const { minimumRegistrationPercentage, minimumAdmissionPercentage } =
    configuration;
  if (!minimumRegistrationPercentage || !minimumAdmissionPercentage) {
    return ERROR_MESSAGES.CONFIGURATION_NOT_SETUP;
  }

  if (enteredAmount === "" || enteredAmount <= 0) {
    return ERROR_MESSAGES.INVALID_AMOUNT;
  }

  if (enteredAmount > totalSelectedAmount) {
    return ERROR_MESSAGES.AMOUNT_EXCEEDS_TOTAL;
  }

  // Function to calculate minimum payment based on percentage
  const calculateMinimumPayment = (component, percentage) => {
    if (!component || component?.totalBalanceAmount === 0) return 0;
    return (component?.totalBalanceAmount * percentage) / 100;
  };

  const registrationComponent = (
    selectedComponents["REGULAR_CHARGES"] || []
  ).find(
    (component) =>
      component?.itemTypeList && component.itemTypeList.includes(REG_ITEM_TYPE)
  );

  const minimumRegistrationPay = calculateMinimumPayment(
    registrationComponent,
    minimumRegistrationPercentage
  );

  if (
    registrationComponent &&
    registrationComponent?.status === "UNPAID" &&
    enteredAmount < minimumRegistrationPay
  ) {
    return getErrorMessage(minimumRegistrationPay);
  }

  const admissionComponent = (selectedComponents["REGULAR_CHARGES"] || []).find(
    (component) =>
      component?.itemTypeList && component.itemTypeList.includes(ADM_ITEM_TYPE)
  );

  const securityComponent = (selectedComponents["REGULAR_CHARGES"] || []).find(
    (component) =>
      component?.itemTypeList && component.itemTypeList.includes(SEQ_ITEM_TYPE)
  );
  let seqItemAmount = 0;
  if (securityComponent && securityComponent?.status === "UNPAID") {
    seqItemAmount = securityComponent?.totalBalanceAmount || 0;
  }

  // if Req, admission and security are selected then total paid would be

  if (admissionComponent && admissionComponent?.status === "UNPAID") {
    const adjustedAmount = enteredAmount - (minimumRegistrationPay || 0) -(seqItemAmount||0);
    const minimumAdmissionPay = calculateMinimumPayment(
      admissionComponent,
      minimumAdmissionPercentage
    );

    if (adjustedAmount < minimumAdmissionPay) {
      const minimumPay =
        minimumAdmissionPay + minimumRegistrationPay + seqItemAmount;
      return getErrorMessage(minimumPay, minimumAdmissionPercentage);
    }
  }

  return null;
};

const getErrorMessage = (minimumPay, admissionMinimum) => {
  if (!admissionMinimum)
    return `Just a heads up, partial payments aren’t allowed for Registration Fees. Please enter amount more than ${formattedPrice(
      minimumPay
    )}`;

  return `You need to pay at least ${admissionMinimum}% for admission fees. Please enter amount more than  ${formattedPrice(
    minimumPay
  )}`;
};
